import { render, staticRenderFns } from "./cards-list-item.vue?vue&type=template&id=c85f5e84&scoped=true&"
import script from "./cards-list-item.vue?vue&type=script&lang=js&"
export * from "./cards-list-item.vue?vue&type=script&lang=js&"
import style0 from "./cards-list-item.vue?vue&type=style&index=0&id=c85f5e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85f5e84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
